/* mjade-cart-feel — 장바구니가 «누르는 즉시» 반응하게 한다 (2026-09-02)
 *
 * 왜 만들었나 [2026-09-02 실측]
 *   지우기를 누르면 화면이 바뀌기까지 왕복을 두 번(경우에 따라 세 번) 기다렸다.
 *     POST /cart/update.js .......... 1,055~1,284ms
 *     GET  /?section_id=<서랍> ......   584~639ms
 *     GET  /?sections=header ........   (개수 표시용, 뒤이어 한 번 더)
 *   그동안 테마는 .cart-form--refreshing 을 걸어 서랍 전체를 «못 누르게» 하고
 *   지울 줄에 .merge-item-refreshing(반투명)을 씌운다. 그래서 «한참 걸리는» 느낌이 났다.
 *   한국몰은 누른 즉시 줄이 사라지고 서버는 뒤에서 따라온다.
 *
 * 여기서 하는 일 — 서버를 기다리지 않고 «보이는 것» 을 먼저 맞춘다:
 *   ① 지우기 → 그 줄을 즉시 접는다(높이·투명도 애니메이션)
 *   ② 그 줄의 금액만큼 «小計» 를 즉시 뺀다
 *   ③ 머리의 장바구니 개수를 즉시 줄인다
 *   ④ 담기 → 서랍을 즉시 연다 (상품은 응답이 오면 채워진다)
 *
 * ★ DOM 에서 «지우지는» 않는다. 테마가 POST 를 만들 때 화면의 수량칸을 훑어
 *   updates 를 만들기 때문에, 줄을 진짜로 없애면 그 상품이 서버에서 안 지워진다.
 *   그래서 보이지 않게만 접고, 실제 제거는 테마의 병합에 맡긴다.
 *
 * 되돌리기: theme.liquid 에서 이 파일 <script> 한 줄을 지운다.
 */
(function () {
  "use strict";
  if (window.__mjCartFeel) return;
  window.__mjCartFeel = true;

  var GONE = "mj-row-gone";

  /* '¥49,500' → 49500. 숫자가 아니면 null 을 준다(그러면 손대지 않는다). */
  function yen(el) {
    if (!el) return null;
    var s = (el.textContent || "").replace(/[^0-9]/g, "");
    return s ? parseInt(s, 10) : null;
  }
  function writeYen(el, n) {
    if (!el || n == null || n < 0) return;
    var t = el.textContent || "";
    var head = t.slice(0, t.search(/[0-9]/));            /* '¥' 같은 앞머리 유지 */
    el.textContent = head + n.toLocaleString("ja-JP");
  }

  function rowTotal(row) {
    var el = row.querySelector(".cart-item__selling-total, .cart-item__total, .cart-item__price .theme-money, .theme-money");
    return yen(el);
  }
  function rowQty(row) {
    var q = row.querySelector(".cart-item__quantity-input");
    var n = q ? parseInt(q.value, 10) : 1;
    return isNaN(n) ? 1 : n;
  }

  /* 소계는 그 장바구니 폼(서랍이든 /cart 페이지든) 안에서 찾는다 */
  function subtotalEl(row) {
    var box = row.closest("cart-drawer") || row.closest("cart-form") || document;
    return box.querySelector(".subtotal .theme-money, .cart-drawer__footer .subtotal .theme-money");
  }

  function collapse(row) {
    if (row.classList.contains(GONE)) return;
    var h = row.getBoundingClientRect().height;
    row.style.height = h + "px";
    row.style.overflow = "hidden";
    row.classList.add(GONE);
    /* rAF 가 멈추는 상황(숨은 탭)에서도 반드시 접히게 시계로도 건다 */
    var done = false;
    function shrink() {
      if (done) return;
      done = true;
      row.style.height = "0px";
      row.style.opacity = "0";
      row.style.paddingTop = "0px";
      row.style.paddingBottom = "0px";
      row.style.marginTop = "0px";
      row.style.marginBottom = "0px";
    }
    requestAnimationFrame(function () { requestAnimationFrame(shrink); });
    setTimeout(shrink, 60);
  }

  function bumpCount(delta) {
    document.querySelectorAll(".cart-link__count").forEach(function (el) {
      var n = parseInt((el.textContent || "").replace(/[^0-9]/g, ""), 10);
      if (isNaN(n)) return;
      var v = Math.max(0, n - delta);
      el.textContent = String(v);
    });
  }

  function removeNow(row) {
    if (!row || row.classList.contains(GONE)) return;
    var line = rowTotal(row);
    var sub = subtotalEl(row);
    var before = yen(sub);
    collapse(row);
    if (line != null && before != null) writeYen(sub, before - line);
    bumpCount(rowQty(row));
  }

  /* ① 지우기 — 가로채기 단계에서 «먼저» 화면을 바꾸고, 테마 처리는 그대로 흐르게 둔다.
     (막지 않는다. 테마가 수량 0 을 넣고 POST 를 보내야 서버에서도 지워진다) */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var rm = t.closest(".cart-item__remove");
    if (rm) { removeNow(rm.closest(".cart-item")); return; }

    /* 수량 1 에서 «−» 를 누르면 0 이 된다 = 지우기와 같다 */
    var down = t.closest(".quantity-down");
    if (down) {
      var row = down.closest(".cart-item");
      if (!row) return;
      if (rowQty(row) <= 1) removeNow(row);
      else qtyNow(row, -1);
      return;
    }
    var up = t.closest(".quantity-up");
    if (up) qtyNow(up.closest(".cart-item"), 1);
  }, true);

  /* 수량 ＋/− — 테마는 700ms 기다렸다가 보내고, 답이 와야 금액이 바뀐다.
     즉 손을 대고 2초 넘게 숫자만 바뀌고 값은 그대로였다. 여기서 먼저 맞춘다.

     ★ 할인이 붙은 줄에는 손대지 않는다. 한 개 값을 «줄 합계 ÷ 수량» 으로 되짚는데,
       할인·묶음이 걸리면 그 나눗셈이 맞지 않는다. 나누어떨어지지 않아도 물러난다.
       (건드리지 않으면 예전처럼 서버 답을 기다렸다 정확한 값이 들어온다) */
  function qtyNow(row, step) {
    if (!row) return;
    if (row.querySelector(".cart-item__item-discounts")) return;
    var q = rowQty(row);
    var next = q + step;
    if (next < 1) return;
    var el = row.querySelector(".cart-item__selling-total, .cart-item__total, .cart-item__price .theme-money, .theme-money");
    var line = yen(el);
    if (line == null || q < 1 || line % q !== 0) return;      /* 나누어떨어질 때만 */
    var unit = line / q;
    var after = unit * next;
    var sub = subtotalEl(row);
    var s = yen(sub);
    writeYen(el, after);
    if (s != null) writeYen(sub, s + (after - line));
    document.querySelectorAll(".cart-link__count").forEach(function (c) {
      var n = parseInt((c.textContent || "").replace(/[^0-9]/g, ""), 10);
      if (!isNaN(n)) c.textContent = String(Math.max(0, n + step));
    });
  }

  /* 병합이 끝나면 접어 둔 흔적을 치운다 (테마가 새 HTML 로 갈아끼운 뒤) */
  function clearMarks() {
    document.querySelectorAll("." + GONE).forEach(function (row) {
      row.classList.remove(GONE);
      row.removeAttribute("style");
    });
  }
  document.addEventListener("on:cart:after-merge", clearMarks);

  /* ② 담기 — 응답을 기다리지 말고 서랍을 «지금» 연다.
     테마도 응답 뒤에 같은 서랍을 여는데, open() 은 같은 처리기를 다시 달아도
     중복되지 않으므로(같은 함수 참조) 두 번 열려도 안전하다.
     ★ 「담은 뒤 동작」 설정이 서랍일 때만 한다. 알림·페이지 이동 설정이면 건드리지 않는다. */
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var act = f.getAttribute("action") || "";
    if (act.indexOf("/cart/add") < 0) return;
    try {
      if (!window.theme || !theme.settings || theme.settings.afterAddToCart !== "drawer") return;
    } catch (err) { return; }
    var dr = document.querySelector(".js-cart-drawer") || document.querySelector("cart-drawer");
    if (!dr) return;
    /* ★ 2026-09-03 — 순서를 뒤집었다 [대표님: 「배너가 올라오기 전에 이미 담겨 있어야 한다」].
       앞판은 서랍을 «먼저» 열고 줄을 나중에 그렸다. 그래서 빈 서랍이 올라온 뒤에
       줄이 뒤늦게 나타났다. 한국방은 올라올 때 이미 들어 있다.
       이제 ① 줄을 그리고 → ② 서랍을 연다. 둘 다 같은 프레임 안이라 사람 눈에는 동시다. */
    try { calmOn(); } catch (err) {}     /* ★ 누르는 순간부터 애니메이션을 끈다 */
    var drew = false;
    try { drew = addProvisional(f); } catch (err) {}
    if (!dr.hasAttribute("open") && typeof dr.open === "function") {
      try { dr.open(); } catch (err) {}
    }
    /* 줄을 못 그렸을 때만 «채워지는 중» 표시를 쓴다. 그렸으면 흐리게 할 이유가 없다. */
    if (!drew) {
      try { dr.classList.add("mj-cart-pending"); } catch (err) {}
    }
  }, true);

  function unpend() {
    document.querySelectorAll(".mj-cart-pending").forEach(function (el) {
      el.classList.remove("mj-cart-pending");
    });
  }
  document.addEventListener("on:cart:add", unpend);
  document.addEventListener("on:cart:after-merge", unpend);
  document.addEventListener("on:cart:error", unpend);
  /* 응답이 아예 안 와도 흐릿한 채로 남지 않게 */
  document.addEventListener("submit", function () { setTimeout(unpend, 6000); }, true);

  /* ═══ ③ 담기 — «누른 즉시» 줄이 보이게 (2026-09-03) ═══════════════════
     [대표님: 「장바구니 서랍 담길 때 바로 담기지가 않는데, 애니메이션 같은 건 빼도 되니
              바로 담기게 가능해?」]

     지금 흐름: 누름 → 서랍은 곧바로 열린다(위 ②) → 그런데 «안은 비어 있다» →
     서버에 담고(0.6~0.9초, 이 몰 왕복) 그 답으로 서랍 HTML 을 통째로 갈아 끼운 뒤에야 줄이 보인다.

     그래서 그 사이를 우리가 채운다:
       · 이미 장바구니에 있는 색이면 → 그 줄의 수량·금액만 곧바로 올린다 (기존 qtyNow 재사용)
       · 없으면 → 임시 줄을 하나 그린다. 사진·이름·색·값·수량은 지금 화면에서 그대로 가져온다.
     서버 답이 오면 테마가 진짜 줄로 갈아 끼우고, 임시 줄은 지운다.

     ★ 임시 줄은 테마의 «합치기 목록»(data-merge-list) «밖» 에 둔다.
       안에 넣으면 테마가 목록을 맞출 때 우리 줄을 자기 것으로 착각한다.
     ★ 값이 안 맞을 위험이 있으면 아예 안 그린다 — 틀린 숫자를 보여주느니 예전대로 기다린다.
     ★ 갈아 끼운 직후 0.2초 동안은 서랍 안 애니메이션을 끈다.
       안 끄면 기프트패키지 접이식이 다시 열리는 동작을 되풀이해 «뭔가 아래로 가는» 것처럼 보인다
       [대표님이 말씀하신 그 움직임]. 사람이 직접 여닫는 애니메이션은 그대로 둔다. */

  var PROV = "mj-prov";

  (function style() {
    if (document.getElementById("mj-prov-style")) return;
    var s = document.createElement("style");
    s.id = "mj-prov-style";
    s.textContent =
      "." + PROV + "{display:flex;gap:12px;align-items:flex-start;padding:14px 0;" +
      "border-bottom:1px solid #D9D4CE;}" +
      "." + PROV + " img{width:64px;height:auto;flex:0 0 64px;display:block;background:#F7F5F2;}" +
      "." + PROV + "__t{font-size:13px;line-height:1.45;color:#181614;}" +
      "." + PROV + "__v{font-size:12px;color:#776F68;margin-top:2px;}" +
      "." + PROV + "__p{font-size:13px;color:#181614;margin-top:6px;}" +
      ".mj-noanim .mjc-gift__wrap,.mj-noanim .mjc-extra__wrap{transition:none !important;}" +
      ".mj-noanim .cart-item{transition:none !important;animation:none !important;}";
    document.head.appendChild(s);
  })();

  function drawer() {
    return document.querySelector(".js-cart-drawer") || document.querySelector("cart-drawer");
  }
  function txt(el) { return el ? (el.textContent || "").trim() : ""; }

  function addProvisional(form) {
    var dr = drawer();
    if (!dr) return false;
    var list = dr.querySelector(".cart-item-list");
    if (!list) return false;
    var vid = (form.querySelector('[name="id"]') || {}).value;
    if (!vid) return false;
    var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || "1", 10);
    if (!qty || qty < 1) qty = 1;

    /* 이미 있는 색이면 그 줄의 수량만 올린다 */
    var body = list.querySelector('[data-merge-list="cart-items"]');
    if (body) {
      var rows = body.querySelectorAll("[data-merge-list-item]");
      for (var i = 0; i < rows.length; i++) {
        var k = rows[i].getAttribute("data-merge-list-item") || "";
        if (k.indexOf("item-key:" + vid + ":") === 0 || k.indexOf("item-key:" + vid + "|") === 0) {
          var row = rows[i].querySelector(".cart-item") || rows[i];
          for (var n = 0; n < qty; n++) qtyNow(row, 1);
          return true;
        }
      }
    }

    /* 없으면 임시 줄을 그린다 — 지금 화면에서 값을 가져온다 */
    var info = document.querySelector(".product-info") || document;
    var name = txt(info.querySelector("h1"));
    if (!name) return false;                             /* 이름을 못 찾으면 안 그린다 */
    var color = "";
    var checked = document.querySelector("variant-picker input[type=radio]:checked");
    if (checked) color = checked.value || "";
    var price = txt(info.querySelector(".price .theme-money, .price__current .theme-money, .theme-money"));
    var img = document.querySelector("media-gallery .main-image .slider__item.is-active img")
           || document.querySelector("media-gallery .main-image img");
    var src = img ? (img.getAttribute("src") || "") : "";

    var el = document.createElement("div");
    el.className = PROV;
    el.setAttribute("data-mj-prov", "1");
    el.innerHTML =
      (src ? '<img alt="" src="' + src.replace(/&width=\d+/, "&width=200") + '">' : "") +
      '<div><div class="' + PROV + '__t"></div>' +
      '<div class="' + PROV + '__v"></div>' +
      '<div class="' + PROV + '__p"></div></div>';
    el.querySelector("." + PROV + "__t").textContent = name;
    el.querySelector("." + PROV + "__v").textContent = color + (qty > 1 ? " × " + qty : "");
    el.querySelector("." + PROV + "__p").textContent = price;
    /* ★ 2026-09-03 — «맨 위» 에 넣는다 [대표님: 「중앙에 살짝 보였다가 1번으로 이동한다」].
       앞판은 목록 맨 아래에 붙였다. 그런데 서버 답이 오면 진짜 줄은 맨 위에 생긴다.
       그래서 아래에 있던 임시 줄이 위로 «옮겨간 것처럼» 보였다.
       처음부터 진짜 줄이 생길 자리(맨 위)에 넣으면 그 움직임 자체가 없어진다.
       여전히 합치기 목록 «밖» 이다 — 안에 넣으면 테마가 자기 줄로 착각한다. */
    if (body && body.parentNode === list) {
      list.insertBefore(el, body);
    } else {
      list.insertBefore(el, list.firstChild);
    }
    bumpCount(-qty);   /* bumpCount 는 «빼는» 함수다 — 담기는 반대 부호 */
    return true;
  }

  function dropProvisional() {
    document.querySelectorAll("[data-mj-prov]").forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  /* ★ 담는 동안은 서랍 안 애니메이션을 끈다.
     · 기프트패키지 접이식이 다시 열리는 동작 → 아래 것들이 «밀려 내려가는» 것처럼 보인다
     · 새로 들어온 줄의 «등장 애니메이션»(data-cc-animate) → 미끄러지며 나타난다
     둘 다 담기와 상관없는 연출이라 그 순간만 뗀다. 사람이 직접 여닫는 동작은 그대로다. */
  var calmFrom = 0;

  function strip(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.hasAttribute && root.hasAttribute("data-cc-animate")) {
      root.removeAttribute("data-cc-animate");
      root.removeAttribute("data-cc-animate-delay");
    }
    if (!root.querySelectorAll) return;
    root.querySelectorAll("[data-cc-animate]").forEach(function (el) {
      el.removeAttribute("data-cc-animate");
      el.removeAttribute("data-cc-animate-delay");
    });
  }

  function calmOn() {
    var dr = drawer();
    if (!dr) return;
    calmFrom = Date.now();
    dr.classList.add("mj-noanim");
    strip(dr);
  }
  function calmOff() {
    calmFrom = 0;
    var dr = drawer();
    if (dr) dr.classList.remove("mj-noanim");
  }
  function calm() { calmOn(); setTimeout(calmOff, 250); }

  /* 서랍에 새 조각이 들어오는 것을 지켜보다가, 담는 중이면 등장표시를 뗀다.
     서랍은 갈아 끼울 때 통째로 바뀌므로 이 방법이라야 «들어오는 순간» 에 뗄 수 있다. */
  (function watchDrawer() {
    var dr = drawer();
    if (!dr || !window.MutationObserver) return;
    new MutationObserver(function (muts) {
      if (!calmFrom || Date.now() - calmFrom > 6000) return;
      for (var i = 0; i < muts.length; i++) {
        var ns = muts[i].addedNodes;
        for (var k = 0; k < ns.length; k++) strip(ns[k]);
      }
    }).observe(dr, { childList: true, subtree: true });
  })();

  /* ★ 2026-09-03 — 삭제·수량도 «갈아 끼우는 순간» 을 가린다 [대표님 결정: 값은 서버 그대로,
     체감만 가린다]. 누르는 순간부터 꺼 두어야 한다 — on:cart:after-merge 는 갈아 끼운 «뒤» 라
     그때 켜면 이미 움직임이 지나간 뒤다(담기에서 겪은 것과 같은 함정).
     ★ 값은 손대지 않는다. 여기서 하는 것은 애니메이션을 잠깐 끄는 것뿐이다. */
  document.addEventListener("click", function (e) {
    var t2 = e.target;
    if (!t2 || !t2.closest) return;
    if (!t2.closest("cart-drawer, .js-cart-drawer")) return;
    if (!t2.closest(".cart-item__remove, .quantity-down, .quantity-up")) return;
    try { calmOn(); } catch (err) {}
    setTimeout(calmOff, 2500);          /* 답이 안 와도 꺼진 채로 굳지 않게 */
  }, true);

  document.addEventListener("on:cart:after-merge", function () { calm(); dropProvisional(); });
  document.addEventListener("on:cart:add", function () {
    dropProvisional();
    setTimeout(calmOff, 250);          /* 갈아 끼움이 끝난 뒤 되살린다 */
  });
  document.addEventListener("on:cart:error", dropProvisional);
  document.addEventListener("submit", function () {
    setTimeout(dropProvisional, 6000);
    setTimeout(calmOff, 6000);         /* 답이 안 와도 애니메이션이 꺼진 채 굳지 않게 */
  }, true);
})();
